// selectors

export const getMyClients = state => {
  return state.MyClients.myClients.list;
};

export const getMyClientsPagination = state => {
  return state.MyClients.myClients.pagination;
};
